// Строка статуса, признак несохранённых изменений, заголовок и счётчики.

import { t } from '../i18n';

import { controls } from './controls';
import { currentLocale } from './locale';
import { refreshScopeFilterControls } from './scope-filter';
import { state } from './state';
import { trCount, tr } from '../ui-i18n';

export function setStatus(message: string, kind: 'normal' | 'success' | 'error' = 'normal'): void {
  controls.globalStatus.textContent = message;
  controls.globalStatus.dataset.kind = kind;
}

export function dashboardStatusLabel(dirty: boolean): string {
  if (dirty) return t(currentLocale(), 'unsaved');
  return t(currentLocale(), 'saved');
}

export function markDirty(dirty = true): void {
  state.dirty = dirty;
  controls.dirtyIndicator.textContent = dashboardStatusLabel(dirty);
  controls.dirtyIndicator.classList.toggle('is-dirty', dirty);
  controls.dirtyIndicator.classList.toggle('is-template', Boolean(!dirty && state.currentTemplateId));
}

export function updateDashboardHeading(): void {
  const name = controls.dashboardName.value.trim() || 'Без названия';
  controls.dashboardTitleText.textContent = name;
  controls.dashboardTitleButton.setAttribute('title', name);
  controls.canvasTitle.textContent = name;
  state.definition.title = name;
}

export function widgetNoun(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return 'виджет';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'виджета';
  return 'виджетов';
}

export function updateWidgetCounter(): void {
  const count = state.definition.widgets.length;
  controls.widgetCounter.textContent = trCount(count, 'виджет', 'виджета', 'виджетов');
  controls.emptyState.hidden = count > 0;
  refreshScopeFilterControls();
}

export function showFormError(message: string): void {
  controls.formError.textContent = message;
  controls.formError.hidden = false;
}

export function clearFormError(): void {
  controls.formError.textContent = '';
  controls.formError.hidden = true;
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

export function formatBytes(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  if (value < 1024) return tr('{0} Б', value);
  if (value < 1024 ** 2) return tr('{0} КБ', (value / 1024).toFixed(1));
  return tr('{0} МБ', (value / 1024 ** 2).toFixed(1));
}

/** Число со словом в нужной форме; при английском интерфейсе — по словарю (ui-i18n.ts). */
export function russianCount(value: number, one: string, few: string, many: string): string {
  return trCount(value, one, few, many);
}
